// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { CpuTempInfo, ICpuTempInfo } from "./Shared.Models.View.Hardware.CpuTempInfo.gen";
import { PowerUsageInfo, IPowerUsageInfo } from "./Shared.Models.View.Hardware.PowerUsageInfo.gen";
import { RamUsageInfo, IRamUsageInfo } from "./Shared.Models.View.Hardware.RamUsageInfo.gen";
import { CpuUsageInfo, ICpuUsageInfo } from "./Shared.Models.View.Hardware.CpuUsageInfo.gen";
import { StorageUsageInfo, IStorageUsageInfo } from "./Shared.Models.View.Hardware.StorageUsageInfo.gen";
import { AsyncUsageInfo, IAsyncUsageInfo } from "./Shared.Models.View.Hardware.AsyncUsageInfo.gen";
import { GCUsageInfo, IGCUsageInfo } from "./Shared.Models.View.Hardware.GCUsageInfo.gen";

export interface IHardwareStatusHistory {
	statusTimestamp: string | undefined;

	cpuTemps: ICpuTempInfo | undefined;

	powerUsage: IPowerUsageInfo | undefined;

	ramUsage: IRamUsageInfo | undefined;

	cpuUsage: ICpuUsageInfo | undefined;

	storageUsage: IStorageUsageInfo | undefined;

	asyncUsage: IAsyncUsageInfo | undefined;

	gcUsage: IGCUsageInfo | undefined;

	$type?: string | undefined;
}
export class HardwareStatusHistory {
	constructor(data?: IHardwareStatusHistory) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.statusTimestamp) { this.statusTimestamp = new Date(data.statusTimestamp); }
		if (data.cpuTemps) { this.cpuTemps = new CpuTempInfo(data.cpuTemps); }
		if (data.powerUsage) { this.powerUsage = new PowerUsageInfo(data.powerUsage); }
		if (data.ramUsage) { this.ramUsage = new RamUsageInfo(data.ramUsage); }
		if (data.cpuUsage) { this.cpuUsage = new CpuUsageInfo(data.cpuUsage); }
		if (data.storageUsage) { this.storageUsage = new StorageUsageInfo(data.storageUsage); }
		if (data.asyncUsage) { this.asyncUsage = new AsyncUsageInfo(data.asyncUsage); }
		if (data.gcUsage) { this.gcUsage = new GCUsageInfo(data.gcUsage); }
	}

	statusTimestamp: Date | undefined = new Date();

	cpuTemps: CpuTempInfo | undefined;

	powerUsage: PowerUsageInfo | undefined;

	ramUsage: RamUsageInfo | undefined;

	cpuUsage: CpuUsageInfo | undefined;

	storageUsage: StorageUsageInfo | undefined;

	asyncUsage: AsyncUsageInfo | undefined;

	gcUsage: GCUsageInfo | undefined;

	static $type: string = "Shared.Models.View.Hardware.HardwareStatusHistory, ";
	$type?: string | undefined = HardwareStatusHistory.$type;
}

